import * as React from 'react';
import MenuItem from '@/components/menu/MenuItem';
import ShortcutHint from '@/components/ShortcutHint';
import { NAV_SHORTCUTS } from '@/constants/shortcuts';

type MenuItemRendererProps = {
  item: any;
  dom: React.ReactNode;
  collapsed: boolean;
};

export default function MenuItemRenderer({ item, dom, collapsed }: MenuItemRendererProps) {
  const isDisabled = item.disabled;
  const navKey = NAV_SHORTCUTS[item.path];
  const inner = (
    <div
      key={item.name}
      style={{ pointerEvents: isDisabled ? 'none' : 'auto', opacity: isDisabled ? 0.8 : 1 }}
    >
      <MenuItem item={item}>{dom}</MenuItem>
    </div>
  );
  if (navKey && !collapsed) {
    return (
      <ShortcutHint shortcutKey={navKey} label={item.name} noRegister inline>
        {inner}
      </ShortcutHint>
    );
  }
  return inner;
}
